import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PolicyLineForm } from "./components/PolicyLineForm";
import { usePolicyLineOperations } from "./hooks/usePolicyLineOperations";
import { PolicyLine } from "./types";

interface PolicyLineDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenChange: (open: boolean) => void;
  selectedPolicyLine?: PolicyLine | null;
}

export const PolicyLineDialog = ({ 
  isOpen, 
  onClose, 
  onOpenChange, 
  selectedPolicyLine 
}: PolicyLineDialogProps) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  
  const { createPolicyLine, updatePolicyLine } = usePolicyLineOperations();

  useEffect(() => {
    if (selectedPolicyLine) {
      setFormData({
        name: selectedPolicyLine.name,
        description: selectedPolicyLine.description || "",
      });
    } else {
      setFormData({
        name: "",
        description: "",
      });
    }
  }, [selectedPolicyLine]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    let success;
    
    if (selectedPolicyLine) {
      success = await updatePolicyLine(selectedPolicyLine.id, formData);
    } else {
      success = await createPolicyLine(formData);
    }

    if (success) {
      onClose();
    }
  };

  const handleChange = (field: string, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{selectedPolicyLine ? "Edit" : "Add"} Policy Line</DialogTitle>
        </DialogHeader>
        <PolicyLineForm
          formData={formData}
          onSubmit={handleSubmit}
          onChange={handleChange}
          onClose={onClose}
          isEdit={!!selectedPolicyLine}
        />
      </DialogContent>
    </Dialog>
  );
};